import React, { useEffect, useState, useContext } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { AuthContext } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import s from '../styles/QRcode.module.css';

const QrCode = () => {
  const { fetchCurrentUser, currentUser } = useContext(AuthContext);
  const { tgsecretkey } = currentUser || {};  // ← получаем из одного объекта
  const botUsername = 'fiveadspro_bot';
  const [seconds, setSeconds] = useState(300); // 5 минут
  const [checkAllowed, setCheckAllowed] = useState(false);
  const navigate = useNavigate();

  const botLink = `https://t.me/${botUsername}?start=${tgsecretkey}`;

  // Таймер обратного отсчета (отключает кнопку проверки)
  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          setCheckAllowed(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Проверка каждые 15 сек: если tg_user_id появился — редиректим
  useEffect(() => {
    const interval = setInterval(async () => {
      await fetchCurrentUser();
    }, 15000);

    return () => clearInterval(interval);
  }, [fetchCurrentUser]);

  // Следим за изменением currentUser — и если появился tg_user_id, уводим
  useEffect(() => {
    if (currentUser && currentUser.tg_user_id) {
      navigate('/dashboard');
    }
  }, [currentUser, navigate]);

  const formatTime = (s) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, '0')}`;
  };

  const handleManualCheck = async () => {
    await fetchCurrentUser();
    if (currentUser?.tg_user_id) {
      navigate('/dashboard');
    } else {
      alert('Telegram ещё не привязан. Попробуйте позже.');
    }
  };

  return (
    <div className={s.container}>
      <img src="/logo_2.png" alt="Five Ads Logo" className={s.logo} />
      <h2>Завершите регистрацию и получите бонус 🎁</h2>
      <p>Отсканируйте QR-код или нажмите на кнопку ниже:</p>
      <QRCodeCanvas value={botLink} size={200} />
      <p>
        <a className={s.botButton} href={botLink} target="_blank" rel="noopener noreferrer">
          Открыть бота
        </a>
      </p>
      <p className={s.loading}>Ожидаем подтверждение... <span className={s.timer}>{formatTime(seconds)}</span></p>
      <button className={s.botButton} onClick={handleManualCheck} disabled={!checkAllowed}>
        Проверить регистрацию
      </button>
      <a href="/logout" className={s.backLink}>Зайти в другой аккаунт</a>
    </div>
  );
};

export default QrCode;
